import { createApp } from 'vue/dist/vue.esm-bundler.js';
import UIComponentLibrary, { FEATHER_LOCALE_KEY } from '@raptor/feather-ui';
import * as vueComponents from './components/index.js';
import "@/@raptor/feather-ui/dist/feather-ui.css";
import icons from '@/@raptor/feather-ui/dist/img/icons.svg';
import { kebabToPascalCase } from '~/helpers/string_helpers.js';

const registerComponent = (app, tagName) => {
  const componentName = kebabToPascalCase(tagName);
  const component = vueComponents[componentName];

  if (!component) return;

  app.component(componentName, component);
}

document.addEventListener('DOMContentLoaded', () => {
  const appContainers = document.querySelectorAll(".vue-container");

  appContainers.forEach(appContainer => {
    const app = createApp();

    // Automatically register all components based on the children of the app container
    [...appContainer.children].forEach((child) => {
      registerComponent(app, child.localName);
    });

    app
      .use(UIComponentLibrary)
      .provide('iconsSvgPath', icons)
      .provide(FEATHER_LOCALE_KEY, gon.feather_locale)
      .mount(appContainer);
  });
});
